import { Component, OnInit, ViewChild } from '@angular/core';
import { IonSearchbar } from '@ionic/angular';
import { Employee } from 'src/app/_interfaces/Employee';
import { BoardService } from 'src/app/_provider/boards/board.service';
import { FeedbackService, VibrateType } from 'src/app/_provider/feedback.service';

@Component({
  selector: 'app-board-user-select',
  templateUrl: './board-user-select.component.html',
  styleUrls: ['./board-user-select.component.scss', '../board-select.scss'],
})
export class BoardUserSelectComponent implements OnInit {

  public selectedAll: boolean = false
  public newEmployeesSelected: (data: Employee[]) => void

  public employees: Employee[] = []
  public employeeFilter: Employee[] = []

  @ViewChild(IonSearchbar) searchBar: IonSearchbar
  public searchText: string = ""

  constructor(
    public boardSrv: BoardService,
    private feedback: FeedbackService
  ) { }

  ngOnInit() {
    this.uncheckAll(false)
    this.employeeFilter = Object.assign([],this.employees)
  }

  async ngAfterViewInit(){
    setTimeout(async() => await this.searchBar.setFocus(), 300);
  }


  public allSelect(){
    if(this.selectedAll){
      this.employees.forEach(e => e.checked = true)
      this.sendCheckedEmployees()
    }
    else{
      this.employees.forEach(e => e.checked = false)
      this.sendCheckedEmployees()
    }
  }

  public uncheckAll(sendEvent: boolean = true){
    if(this.employees.every(e => e.checked)){
      this.selectedAll = true
      if(sendEvent) this.sendCheckedEmployees()
    }
    else{
      this.selectedAll = false
      if(sendEvent)this.sendCheckedEmployees()
    }
  }

  public search(){
    this.employeeFilter = this.employees.filter(e => e.firstName.toLowerCase().includes(this.searchText.toLowerCase()))
  }

  public select(){
    if(this.employees.length == 1) this.employees[0].checked = !this.employees[0].checked
  }

  private sendCheckedEmployees(){
    this.feedback.vibrate(VibrateType.light)
    this.newEmployeesSelected(this.employees.filter(e => e.checked))
  }

}
